
import Vue from 'vue';

interface IRestXUser {
    data: User | null;
}
import { VideoChat } from '~/models/communication';
import { User } from '~/services/IdentityService';
import userDataToName from '~/utils/user/userDataToName';

// components
import MinimizedVideo from './components/MinimizedVideo.vue';
export default Vue.extend({
    name: 'MinimizedVideoChat',
    components: {
        MinimizedVideo,
    },
    methods: {
        fullName(): string {
            return userDataToName(this.user.data, 'chat.videoDialog.guest');
        },
    },
    computed: {
        interfaces(): any {
            return (this as any).$interfaces;
        },
        videoCalls(): Array<VideoChat> {
            // @ts-ignore TODO: Fix this
            return this.$interfaces.videoCallModule.getVideoCalls() as Array<VideoChat>;
        },
        containsMaximized(): boolean {
            return (
                this.videoCalls.filter((videoCall: VideoChat) => !videoCall.minimized).length > 0
            );
        },
        user(): IRestXUser {
            // @ts-ignore TODO: Fix this
            return this.$interfaces.user.me.get({ reactive: true });
        },
    },
    watch: {
        user(newUser: IRestXUser, _: IRestXUser) {
            if (!!newUser.data) {
                // @ts-ignore TODO: Fix this
                this.$interfaces.videoCallModule.getFromPersistantStorage(this.fullName);
            }
        },
    },
});
